import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.air-brief.com';

// Public course/bundle catalogue with USD prices (same endpoint the Store uses).
const usePublicStore = () => {
  const [store, setStore] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/api/payments/store/`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => { if (!cancelled) setStore(d); })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, []);

  return { store, error, loading: !store && !error };
};

// Cheapest price per 30 days among a list of tiers, for "from $X / month" labels.
export const monthlyFrom = (tiers = []) => {
  const monthly = tiers
    .filter((t) => t.is_active !== false && t.duration_days >= 28)
    .map((t) => parseFloat(t.price) / (t.duration_days / 30));
  return monthly.length ? Math.min(...monthly) : null;
};

export default usePublicStore;
